import React, { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { compressImage } from "@/lib/image";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function FileUpload({ value = [], onChange, label, testid = "file-upload", max = 6 }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const pick = () => inputRef.current?.click();

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    if (value.length + files.length > max) { toast.error(`Maksimal ${max} foto`); return; }
    setBusy(true);
    try {
      const urls = [];
      for (const f of files) {
        if (f.size > 50 * 1024 * 1024) {
          toast.error(`File ${f.name} melebihi batas maksimal 50MB`);
          continue;
        }
        const fileToUpload = await compressImage(f);
        const fd = new FormData();
        fd.append("file", fileToUpload);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(`${BACKEND}/api/files/${data.path}`);
      }
      onChange([...value, ...urls]);
    } catch (e2) { toast.error(errMsg(e2, "Gagal mengunggah")); }
    finally { setBusy(false); if (inputRef.current) inputRef.current.value = ""; }
  };

  const remove = (url) => onChange(value.filter((u) => u !== url));

  return (
    <div>
      {label && <label className="text-xs font-semibold text-rl-muted">{label}</label>}
      <div className="mt-1 flex flex-wrap gap-2">
        {value.map((url) => (
          <div key={url} className="relative w-20 h-20 rounded-lg overflow-hidden border border-rl-border group">
            <img src={url} alt="" className="w-full h-full object-cover" />
            <button type="button" data-testid={`${testid}-remove`} onClick={() => remove(url)}
              className="absolute top-0.5 right-0.5 bg-black/60 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
        {value.length < max && (
          <button type="button" data-testid={testid} onClick={pick} disabled={busy}
            className="w-20 h-20 rounded-lg border-2 border-dashed border-rl-border hover:border-rl-primary grid place-items-center text-rl-muted hover:text-rl-primary transition-colors">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Upload className="w-5 h-5" />}
          </button>
        )}
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple hidden onChange={handleFiles} data-testid={`${testid}-input`} />
    </div>
  );
}
